<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.name"
        placeholder="关键字搜索(名称)"
        style="width: 300px"
        class="filter-item"
        clearable
      />

      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        @click="checkDialogFormVisible(true)"
        >新增</el-button
      >
    </div>

    <div style="margin: 5px 0">会员数量:{{ total }}</div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <!-- <el-table-column
        align="center"
        prop="id"
        label="ID"
        width="95"
      ></el-table-column> -->
      

      <el-table-column label="ID" align="center" prop="id"></el-table-column>

      <el-table-column
        align="center"
        prop="agentName"
        label="代理名称"
        width="120px"
      ></el-table-column>
      <el-table-column
        label="分润比例"
        align="center"
        prop="ratio"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="ctdate"
        label="创建时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="mddate"
        label="修改时间"
        width="200px"
      >
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="100"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <div style="display:flex">
            <el-button
              type="primary"
              size="mini"
              @click="onUpdateAgentConfig(scope.row)"
              class="comm_but_warp"
              >修改</el-button
            >

            <!-- <el-button
              type="primary"
              size="mini"
              @click="onDeleteAgentConfig(scope.row)"
              class="comm_but_warp"
              >删除</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!--    新增会员-->
    <el-dialog
      :title="`${form.id ? '编辑' : '新增'}代理商`"
      :visible.sync="addDialogFormVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="checkDialogFormVisible(false)"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="150px"
        style="width: 80%; margin-left:50px;"
      >
        <el-form-item label="代理名称" prop="mobile">
          <el-input v-model="form.agentName" placeholder="请输入" />
        </el-form-item>
        <el-form-item label="分润比例" prop="password">
          <el-input v-model="form.ratio" placeholder="请输入" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="checkDialogFormVisible(false)">取消</el-button>
        <el-button
          type="primary"
          @click="saveAddOrEditData"
          :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAgentWithdrawInfoList,
  updateAgentConfig,
  addAgentConfig,
  deleteAgentConfig,
} from "@/api/agent";
import { formatApiDate } from "@/utils/utils";

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        name: null,
      },
      btnLoading: false,
      form: {
        id: null,
        agentName: null,
        ratio: null
      },
      rules: {
        agentName: [
          { required: true, message: "代理名称不能为空", trigger: "change" },
        ],
        ratio: [
          { required: true, message: "分润比例不能为空", trigger: "change" },
        ],
      },
      addDialogFormVisible:false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      getAgentWithdrawInfoList(this.listQuery).then((res) => {
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
        this.listLoading = false;
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },

    onUpdateAgentConfig(row) {
      console.log("上传图片getAttDataValueFunc", row);
      this.form = row;
      this.addDialogFormVisible = true;
    },
    onDeleteAgentConfig(row) {
      deleteAgentConfig({ id: row.id }).then((res) => {
        this.$message.success("删除成功");
        this.getList();
      });
    },
    saveAddOrEditData() {
      const mapConfig = this.form.id ? updateAgentConfig : addAgentConfig;
      mapConfig(this.form).then((res) => {
        this.$message.success("保存成功");
        this.checkDialogFormVisible(false);
        this.getList();
      });
    },
    checkDialogFormVisible(status) {
      console.log("checkDialogFormVisible", status);
      if (!status) {
        this.$refs.form.resetFields();
      }
      this.key++;
      this.addDialogFormVisible = status;
    },
  },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-list {
  ::v-deep .upload_list_warp {
    .el-upload {
      width: 80px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  ::v-deep .el-upload__tip {
    display: none;
  }
}
</style>
